// src/pages/Assistant.js
// KarviAI general assistant (ChatGPT-style) → /api/assistant/chat.
// Separate from character chat: no persona, Sarvam-backed, 48h auto-delete.

import { useEffect, useRef, useState } from "react";
import { assistant } from "../api";

export default function Assistant() {
  const [messages, setMessages] = useState([]);
  const [input, setInput] = useState("");
  const [sending, setSending] = useState(false);
  const [loading, setLoading] = useState(true);
  const [err, setErr] = useState("");
  const scroller = useRef(null);

  const scrollDown = () =>
    requestAnimationFrame(() => {
      if (scroller.current) scroller.current.scrollTop = scroller.current.scrollHeight;
    });

  useEffect(() => {
    assistant
      .get()
      .then((d) => setMessages(d.messages || []))
      .catch(() => {})
      .finally(() => {
        setLoading(false);
        scrollDown();
      });
  }, []);

  const send = async () => {
    const text = input.trim();
    if (!text || sending) return;
    setErr("");
    setInput("");
    setMessages((m) => [...m, { role: "user", content: text }]);
    setSending(true);
    scrollDown();
    try {
      const res = await assistant.send(text);
      setMessages((m) => [...m, { role: "assistant", content: res.response }]);
    } catch (e) {
      setErr(e.message);
      setMessages((m) => m.slice(0, -1));
      setInput(text);
    } finally {
      setSending(false);
      scrollDown();
    }
  };

  const newChat = async () => {
    await assistant.newChat().catch(() => {});
    setMessages([]);
  };

  const onKey = (e) => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      send();
    }
  };

  return (
    <div className="chat">
      <header className="chat__head">
        <div className="chat__who">
          <div className="chat__name grad-text">KarviAI Assistant</div>
          <div className="chat__sub">Coding, writing, ideas, anything</div>
        </div>
        <button className="btn btn--ghost" style={{ marginLeft: "auto" }} onClick={newChat}>New chat</button>
      </header>

      <div className="chat__scroll" ref={scroller}>
        {loading ? (
          <div className="chat__loading">Loading…</div>
        ) : messages.length === 0 ? (
          <div className="chat__loading">Ask me anything to get started.</div>
        ) : (
          messages.map((m, i) => (
            <div key={i} className={`bubble bubble--${m.role}`}>
              <div className="bubble__text">{m.content}</div>
            </div>
          ))
        )}
        {sending && (
          <div className="bubble bubble--assistant">
            <div className="bubble__text typing"><span></span><span></span><span></span></div>
          </div>
        )}
      </div>

      {err && <div className="form-error center">{err}</div>}

      <div className="composer">
        <textarea rows={1} placeholder="Message KarviAI…" value={input} onChange={(e) => setInput(e.target.value)} onKeyDown={onKey} />
        <button className="btn btn--primary" onClick={send} disabled={sending || !input.trim()}>Send</button>
      </div>
    </div>
  );
}
